import $ from 'jquery';
import {Scheduler} from './Scheduler.js';
import {elementInViewport, isVisible} from './functions';

const MORPHED_ELEMENT = 'circle';
const GROUP_ELEMENT = 'g';

const $document = $(document);

class MultiMorphSVG
{
    constructor() {
        this.graphics = [];
        this.maxElementsAmount = 0;
        this.duration = 0;
        this.timeout = 0;
        this.afterAnimate = () => {
        };
    }

    addGraphics() {
        let argsArr = Array.prototype.slice.call(arguments);

        $.each(argsArr, (i, $graphic) => {
            let graphicData = {
                $element: $graphic,
                data: [],
                assignment: []
            };

            this.graphics.push(graphicData);
        });
    }

    _prepare() {
        this._countMaxElements();
        this._setGraphicsData();
        this._setGraphicsAssignment();
    }

    _countMaxElements() {
        $.each(this.graphics, (i, graphic) => {
            let amount = graphic.$element.find(MORPHED_ELEMENT).length;

            if (amount > this.maxElementsAmount) {
                this.maxElementsAmount = amount;
            }
        });
    }

    _setGraphicsData() {
        $.each(this.graphics, (i, graphic) => {
            this._prepareGroups(graphic);
            this._createMissingElements(graphic);
            this._setData(graphic);
        });
    }

    _prepareGroups(graphic) {
        let $graphic = graphic.$element;

        $graphic.find(GROUP_ELEMENT).each((i, group) => {
            let $group = $(group),
                translate = this._getRemovedTranslate($group),
                fill = this._getRemovedFill($group);

            this._prepareMorphedElements($graphic, $group, translate, fill);
        });
    }

    _createMissingElements(graphic) {
        let $graphic = graphic.$element,
            graphicElementsAmount = $graphic.find(MORPHED_ELEMENT).length,
            i;

        for (i = 0; i < (this.maxElementsAmount - graphicElementsAmount); i++) {
            $graphic.append($('<circle>')
                .css({
                    transition: this.duration + 'ms linear fill',
                    opacity: 1
                })
            );
        }
    }

    _setGraphicsAssignment() {
        $.each(this.graphics, (i, graphic) => {
            let $graphic = graphic.$element;

            this._setAssignment(graphic, this._getNextGraphic(i));
        });
    }

    _getNextGraphic(i) {
        return this.graphics[this._getNextGraphicId(i)];
    }

    _getNextGraphicId(i) {
        if (i + 1 >= this.graphics.length) {
            return 0;
        }

        return (i + 1);
    }

    _getRemovedTranslate($group) {
        let transformStr = $group.attr('transform'),
            translateArr,
            translate;

        if (transformStr !== undefined) {
            translateArr = transformStr
                .replace(/translate\(|\)/g, '')
                .split(',');

            translate = {
                x: translateArr[0],
                y: translateArr[1]
            };

            $group.removeAttr('transform');
        }

        return translate;
    }

    _getRemovedFill($group) {
        let fill = $group.attr('fill');

        if (fill !== undefined) {
            $group.removeAttr('fill');
        }

        return fill;
    }

    _prepareMorphedElements($graphic, $group, translate, fill) {
        $group.find(MORPHED_ELEMENT).each((i, element) => {
            let $element = $(element);

            if (translate !== undefined) {
                $element.attr('cx', parseInt($element.attr('cx')) + parseInt(translate.x));
                $element.attr('cy', parseInt($element.attr('cy')) + parseInt(translate.y));
            }

            if (fill !== undefined) {
                $element.attr('fill', fill);
            }

            $element.removeAttr('transform');

            $element
                .closest($graphic)
                .append($element);
        });
    }

    _setData(graphic) {
        graphic.$element.find(MORPHED_ELEMENT).each((i, element) => {
            let $element = $(element);

            graphic.data[i] = {
                x: $element.attr('cx'),
                y: $element.attr('cy'),
                r: $element.attr('r'),
                fill: $element.attr('fill'),
                id: i
            };
        });
    }

    _setAssignment(graphic, nextGraphic) {
        let availableElements = nextGraphic.data.concat();

        $.each(graphic.data, (i, elementData) => {
            let nearestElement = this._getNearestElement(elementData, availableElements);

            if (nearestElement !== undefined) {
                graphic.assignment[i] = nearestElement.id;
            }
        });
    }

    _getNearestElement(elementData, nextGraphicData) {
        nextGraphicData.sort(this._sortDistance(elementData));

        return nextGraphicData.shift();
    }

    _sortDistance(point0) {
        return (a, b) => {
            var ac = this._getDistance(a.x - point0.x, a.y - point0.y),
                bc = this._getDistance(b.x - point0.x, b.y - point0.y);

            return ac - bc;
        };
    }

    _getDistance(x, y) {
        return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    }

    run(duration = 1000, timeout = 5000) {
        this.duration = duration;
        this.timeout = timeout;

        this._prepare();
        this._animate();
    }

    _animate(i = 0) {
        let length = this.graphics.length,
            pause = true,
            $graphic = this.graphics[0].$element;

        for (let j = 0; j < length; j++) {
            let element = this.graphics[j].$element[0];

            if (elementInViewport(element) && isVisible(element)) {
                pause = false;
            }
        }

        if (pause || document.hidden || document.msHidden || document.webkitHidden || document.mozHidden) {
            Scheduler.add(() => this._animate(i), this, 50, true);
            return;
        }

        $graphic.find(MORPHED_ELEMENT).each((j, element) => {
            let $element = $(element),
                newId = j,
                k;

            for (k = 0; k <= i; k++) {
                newId = this.graphics[k].assignment[newId];
            }

            $element.css('transition', this.duration + 'ms fill');

            if (newId !== undefined) {
                let newData = this._getNextGraphic(i).data[newId];

                if (newData.x !== undefined) {
                    $element
                        .animate({
                            cx: newData.x,
                            cy: newData.y,
                            r: newData.r,
                            opacity: 1
                        }, this.duration)
                        .css({
                            fill: newData.fill
                        });
                } else {
                    $element.velocity({opacity: 0}, this.duration);
                }
            } else {
                $element.velocity({opacity: 0});
            }
        });
        setTimeout(() => {
            this.afterAnimate(i);
        }, this.duration);

        setTimeout(() => {
            this._animate(this._getNextGraphicId(i));
        }, this.timeout);
    }
}

class SVGMultiAnimator
{
    constructor($graphic) {
        this.$graphic = $graphic;
        this.style = null;
        this.configuration = {};
        this.duration = 0;
        this.timeout = 0;
        this.elementsAmount = 0;
    }

    setStyle(style) {
        this.style = style;
    }

    configure(configuration) {
        this.configuration = configuration;
    }

    run(duration, timeout) {
        this.duration = duration;
        this.timeout = timeout;

        this._prepare();
        this._animate();
    }

    _getRandomColor() {
        let colors = this.configuration.colors,
            rand = Math.random() * colors.length;

        return colors[Math.floor(rand)];
    }

    _getRandomChanceColor() {
        let colors = this.configuration.colors,
            rand = Math.random(),
            color = null,
            sum = 0,
            i;

        for (i = 0; i < colors.length; i++) {
            color = colors[i];

            if (sum + color.chance > rand) {
                break;
            }

            sum += color.chance;
        }

        return color.fill;
    }

    _getRandomValueFromRange(min, max) {
        let rand = Math.random();

        return (rand * (max - min) + min);
    }

    _prepare() {
        let $elements = this.$graphic.find(MORPHED_ELEMENT);

        this.elementsAmount = $elements.length;
        $elements.css('transition', this.duration + 'ms fill linear');
    }

    _animate() {
        if (this.style === 'random') {
            this._animateRandom();
        }

        if (this.style === 'random_chance') {
            this._animateRandomChance();
        }

        if (this.style === 'random_point_chance' || this.style === 'random_point_black') {
            this._animateRandomPointChance();
        }

        if (this.style === 'random_pulse') {
            this._animateRandomPulse();
        }

        if (this.style === 'one_color') {
            this._animateOneColor();
        }
    }

    _animateRandom() {
        this.$graphic.find(MORPHED_ELEMENT).each((i, element) => {
            element.style.fill = this._getRandomColor();
        });

        this._animateTimeout();
    }

    _animateRandomChance() {
        this.$graphic.find(MORPHED_ELEMENT).each((i, element) => {
            element.style.fill = this._getRandomChanceColor();
        });

        this._animateTimeout();
    }

    _animateRandomPointChance() {
        let rand = Math.random(),
            randomIndex = Math.floor(rand * this.elementsAmount),
            $element = this.$graphic.find(MORPHED_ELEMENT).eq(randomIndex),
            color = this._getRandomChanceColor();

        if ($element.css('fill') === color) {
            this._animateRandomPointChance();
        }

        $element.css('fill', color);

        this._animateTimeout();
    }

    _animateRandomPulse() {
        this.$graphic.find(MORPHED_ELEMENT).each((i, element) => {
            let $element = $(element),
                radiusRange = this.configuration.radiusRange,
                radius = this._getRandomValueFromRange(radiusRange[0], radiusRange[1]);

            $element.animate({r: radius}, this.duration);
        });

        this._animateTimeout();
    }

    _animateOneColor() {
        let color = this.$graphic.parent().css('color');

        this.configuration.colors = [
            {
                fill: '#D8D8D8',
                chance: 0.8
            },
            {
                fill: color,
                chance: 0.2
            }
        ];
        this.$graphic.find(MORPHED_ELEMENT).each((i, element) => {
            element.style.fill = this._getRandomChanceColor();
        });

        this._animateTimeout();
    }

    _animateTimeout() {
        if (!isVisible(this.$graphic[0])) {
            Scheduler.add(this._animateTimeout, this, 500);
            return;
        }
        Scheduler.add(this._animate, this, this.timeout);
    }
}

export class SVGSingleAnimator
{
    static getQuarterData(radius) {
        let strokeDashArray = 2 * Math.PI * radius,
            full = strokeDashArray / 2;

        return {
            radius: radius,
            strokeDashArray: strokeDashArray,
            full: full
        };
    }

    static getQuarterStrokeDashOffset(data, percentage) {
        return data.strokeDashArray * (percentage) / 100;
    }

}

function patternAnim(style, configuration, duration, timeout) {
    let $that = $(this),
        animator = new SVGMultiAnimator($that);

    animator.setStyle(style);
    animator.configure(configuration);
    animator.run(duration, timeout);
}

function createPatternAnimation(style, configuration, duration, timeout) {
    if (window.isMobileOrTablet) {
        return;
    }
    $('img.pattern.animation-' + style + ', .pattern.animation-' + style + ' img')
        .on('img2svg:replaced', function(e, $svg) {
            patternAnim.call($svg.get(0), style, configuration, duration, timeout);
        });
    $('svg.pattern.animation-' + style + ', svg .pattern.animation-' + style + ', .pattern.animation-' + style + ' svg')
        .each(function() {
            if ($(this).closest('.scroll-fixed-slider').length > 0) {
                return;
            }
            patternAnim.call(this, style, configuration, duration, timeout);
        });
}

export var CirclesAnimation = {
    patternCounter: 0,
    exludedCircles: '[class*="dna-animation"], .excluded-circle',
    animationTiming: {
        default: {
            firstAnimationMin: 1000,
            firstAnimationMax: 4000,
            secondAnimationDelay: 1000,
            secondAnimationMin: 10,
            secondAnimationMax: 2000
        },
        services: {
            firstAnimationMin: 1000,
            firstAnimationMax: 3000,
            secondAnimationDelay: 250,
            secondAnimationMin: 10,
            secondAnimationMax: 1000
        },
        fixedSlider: {
            firstAnimationMin: 500,
            firstAnimationMax: 1000,
            secondAnimationDelay: 50,
            secondAnimationMin: 10,
            secondAnimationMax: 50
        }
    },
    getAnimationTiming: function(animationType) {
        let $servicesPage = $('.services-page');

        if ($servicesPage.length > 0) {
            return CirclesAnimation.animationTiming.services;
        } else if (animationType) {
            return CirclesAnimation.animationTiming.fixedSlider;
        } else {
            return CirclesAnimation.animationTiming.default;
        }
    },

    animateDots: function($circles, minTime, maxTime) {
        if ($circles.closest('.slider-slides').length > 0) {
            $circles.velocity({opacity: 1}, {duration: 300, delay: 1000});
        } else {
            $circles.each(function() {
                var $t = $(this),
                    time = Math.random() * 30;

                Scheduler.add(
                    function() {
                        var animationDuration = Math.random() * maxTime,
                            transition = $t.css('transition');

                        if (animationDuration < minTime) {
                            animationDuration = minTime;
                        }
                        if (animationDuration > maxTime) {
                            animationDuration = maxTime;
                        }
                        $t.velocity({opacity: 1}, {duration: animationDuration});

                        // Check if transition time is not 0s
                        if ((transition.match(/0s/g) || []).length < 2) {
                            Scheduler.add(function () {
                                $t.css({
                                    'transition': transition
                                });
                            }, null, animationDuration, true);
                        }
                    }, null, time, true
                );

            });
        }
    },

    runAnimationSequence: function(details, isJquery) {
        var $b,
            animationTimingConf = CirclesAnimation.getAnimationTiming(isJquery);

        if (isJquery) {
            $b = details;
        } else {
            $b = $('[data-aos-id=' + details.type.substr(7) + ']');
        }

        CirclesAnimation.animateDots(
            $b.find('[fill="#DCDCDC"], [fill="#333"]')
                .find('circle')
                .not(CirclesAnimation.exludedCircles)
                .addClass('circle-animated'),
            animationTimingConf.firstAnimationMin,
            animationTimingConf.firstAnimationMax
        );

        Scheduler.add(function() {
            CirclesAnimation.animateDots(
                $b.find('circle').not(CirclesAnimation.exludedCircles).not('.circle-animated'),
                animationTimingConf.secondAnimationMin,
                animationTimingConf.secondAnimationMax
            );
        }, null, animationTimingConf.secondAnimationDelay, true);
    },

    prepareShowDots: function(fire) {
        var $t = $(this),
            $parent = $t.parents('[data-aos]'),
            aosHandle;

        $t.addClass('dots-prepared').find('circle').not(CirclesAnimation.exludedCircles).stop();
        if (fire === true) {
            return;
        }
        $t.attr('data-aos', 'show-dots').attr('data-aos-id', 'show-dots-' + ++CirclesAnimation.patternCounter);
        aosHandle = $parent.attr('id');
        if (typeof aosHandle !== 'string') {
            $parent.attr('id', 'pattern-wave-' + CirclesAnimation.patternCounter);
            if ($parent.hasClass('service')) {
                aosHandle = '#pattern-wave-' + CirclesAnimation.patternCounter
            }
        } else {
            aosHandle = '#'+aosHandle;
        }
        $t.attr('data-aos-anchor', aosHandle);
        $document
            .one('aos:in:show-dots-' + CirclesAnimation.patternCounter, CirclesAnimation.runAnimationSequence);
    }
};

let dotsAnimationDelay = 1000;

function init() {
    createPatternAnimation('random_chance', {
        colors: [
            {
                fill: '#D8D8D8',
                chance: 0.75
            },
            {
                fill: '#000000',
                chance: 0.12
            },
            {
                fill: '#3255C8',
                chance: 0.1
            },
            {
                fill: '#FFA342',
                chance: 0.03
            }
        ]
    }, 1000, 1000);
    createPatternAnimation('random_point_chance', {
        colors: [
            {
                fill: '#D8D8D8',
                chance: 0.75
            },
            {
                fill: '#666666',
                chance: 0.22
            },
            {
                fill: '#3255C8',
                chance: 0.02
            },
            {
                fill: '#FFA342',
                chance: 0.01
            }
        ]
    }, 150, 150);
    createPatternAnimation('random_point_black', {
        colors: [
            {
                fill: '#333333',
                chance: 0.75
            },
            {
                fill: '#D8D8D8',
                chance: 0.22
            },
            {
                fill: '#3255C8',
                chance: 0.02
            },
            {
                fill: '#FFA342',
                chance: 0.01
            }
        ]
    }, 150, 50);
    createPatternAnimation('random_pulse', {
        radiusRange: [1, 2]
    }, 600, 1000);
    createPatternAnimation('one_color', {}, 600, 1500);
    $document.one('aos:in:page-footer-a', function() {
        Scheduler.add(function() {
            $('.pattern-webini-animate').each(function() {
                let $that = $(this),
                    $parent = $that.parent(),
                    $svg = $parent.find('.pattern-webini-animate'),
                    morph = new MultiMorphSVG();

                morph.addGraphics($svg.find('#icon2'), $svg.find('#icon1'));
                morph.afterAnimate = function(i) {
                    if (i === 0) {
                        this.graphics[0].$element.find('.light').css({
                            fill: '#FFA342'
                        }, 750);
                    }
                };
                morph.run(2000, 5000);
            });
        }, null, 5000, true);
    });
}

if ($('.main-slider').length > 0) {
    dotsAnimationDelay = 10000;
}

if (!window.isMobileOrTablet) {
    $(window).on('load', function() {
        Scheduler.add(init, null, dotsAnimationDelay);
        $('.pattern').not('.pattern-webini-animate, .dots-prepared, .animation-one_color')
            .each(CirclesAnimation.prepareShowDots)
            .on('img2svg:replaced', CirclesAnimation.prepareShowDots);
    });
}
